// extracted by mini-css-extract-plugin
export default {"text":"ForgotPassword_text__Bsfcr","secondary":"ForgotPassword_secondary__E3GE8","backLink":"ForgotPassword_backLink__-xOsh","logo":"ForgotPassword_logo__C3vHD"};